import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {CardContent, IconButton, Box, Menu, MenuItem} from '@mui/material';
import {ReactComponent as KebabMenu} from '../../assets/images/kebab.svg';
import {ReactComponent as ArrowForwardIcon} from '../../assets/images/view-arrow.svg';
import {ReactComponent as MccLogo} from '../../assets/images/mcc-icon.svg';
import {ReactComponent as DisbursementDownload} from '../../assets/images/disbursementDownload.svg';
import nameCard from './nameCard.module.css';
import {useDispatch, useSelector} from 'react-redux';
import {leadValue} from '../../state/slice/leadSlice';
import {useNavigate} from 'react-router-dom';
import Path from '../../constants/path';
import {setMcclistValue} from '../../state/slice/mccListSlice';
import Strings from '../../constants/stringConstant';
import {loanValue} from '../../state/slice/loanListPayloadSlice';
import {getInitial, hasEditValue} from '../../utils/appUtils';
import {lmsBrNetApiCall} from '../../api/request/masterFetchApi/masterFetchApi';
import {toast} from 'react-toastify';
import ModalwithButton from '../Modal/modalwithButton';
import makeApiCall from '../../api/makeApiCall';

const NameCard = ({cardData, setRejectModal, dashboardType}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const {roleBased} = useSelector(state => state.rbacValue);
  const [breRejectedModal, setBreRejectedModal] = useState(false);
  const [breMessage, setBreMessage] = useState('');
   const {productCategories} = useSelector(
      state => state.productFilterSlice,
    );
  const isManageAssignee =
    dashboardType === Strings.manageReassignement.manageReassignementHeader;
  const isMcc = dashboardType === 'Mcc';
  const isLead = dashboardType === 'Lead';
  const isQDE = dashboardType === Strings.loan_applications.qde;
  const isRejectApplication =
    dashboardType === Strings.loan_applications.dashBoard_type_rejected;
  const isDDE = dashboardType === Strings.loan_applications.dde;
  const isFI = dashboardType === Strings.loan_applications.dashboard_type_fi;
  const isReviewFI =
    dashboardType === Strings.loan_applications.dashboard_type_review_fi;
  const isReviewCD =
    dashboardType === Strings.loan_applications.dashboard_type_review_cd;
  const isPersonalDiscussion =
    dashboardType === Strings.loan_applications.dashboard_type_personal_dis;
  const isOnhold =
    dashboardType === Strings.loan_applications.dashboard_type_onhold;
  const isEligiblity =
    dashboardType === Strings.loan_applications.dashboard_type_eligiblity;
  const isConversation =
    dashboardType === Strings.loan_applications.dashboard_type_con;
  const isOrderConfirmation =
    dashboardType === Strings.loan_applications.dashboard_type_order_con;
  const isApprovalFLow =
    dashboardType === Strings.loan_applications.dashboard_type_approval_flow;
  const isLoanBooking =
    dashboardType === Strings.loan_applications.dashboard_type_loan_booking;
  const isDocEsign =
    dashboardType === Strings.loan_applications.dashboard_type_doc_esign;
  const isDocVerify =
    dashboardType === Strings.loan_applications.dashboard_type_doc_verify;
  const isPartnerApproval =
    dashboardType === Strings.loan_applications.dashboard_type_part_approval;
  const isDisbursement =
    dashboardType === Strings.loan_applications.dashboard_type_disbursement;

  const showKebabMenu =
    (isMcc && hasEditValue(roleBased?.mcc)) ||
    (isLead &&
      ['Incomplete', 'Follow_up'].includes(cardData?.status) &&
      hasEditValue(roleBased?.lead)) ||
    (isQDE && hasEditValue(roleBased?.qde)) ||
    (isDDE && hasEditValue(roleBased?.dde)) ||
    (isFI && hasEditValue(roleBased?.field_investigation)) ||
    (isReviewFI && hasEditValue(roleBased?.review_and_fi)) ||
    (isReviewCD && hasEditValue(roleBased?.review)) ||
    (isPersonalDiscussion && hasEditValue(roleBased?.personal_discussion)) ||
    isOnhold ||
    (isEligiblity && hasEditValue(roleBased?.eligibility_check_and_cam)) ||
    isConversation ||
    (isOrderConfirmation && hasEditValue(roleBased?.order_confirmation)) ||
    (isApprovalFLow && hasEditValue(roleBased?.approval_flow)) ||
    (isLoanBooking && hasEditValue(roleBased?.loan_booking)) ||
    (isDocEsign && hasEditValue(roleBased?.document_execution)) ||
    (isDocVerify && hasEditValue(roleBased?.document_verification)) ||
    (isPartnerApproval && !true) ||
    (isDisbursement &&
      ['INCOMPLETE', 'READY'].includes(cardData?.status) &&
      hasEditValue(roleBased?.disbursement));
  const showDownloadedApp =
    isDisbursement &&
    cardData?.status === 'Pending for Fund Transfer' &&
    cardData?.isCsvDownloaded;

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleMenuOpen = event => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const callLmsBrNetApi = async () => {
    try {
      const response = await makeApiCall(
        lmsBrNetApiCall({
          loanApplicationId: cardData?.loanApplicationId,
        }),
      );

      if (response?.data?.status === Strings.success) {
        navigate(Path.loan_disbursement_applicant);
      } else {
        if (
          ['SAMASTA150', 'SAMASTA151'].includes(
            response?.data?.error?.errorCode,
          )
        ) {
          setBreMessage(response?.data?.error?.errorMessage);
          setBreRejectedModal(true);

          setTimeout(() => {
            setBreRejectedModal(false);
            navigate('/loan-application');
          }, 2000);
        }
      }
    } catch (error) {
      toast.error(Strings.apiError);
    }
  };
  const handleEdit = event => {
    event.stopPropagation();
    switch (dashboardType) {
      case 'Lead':
        dispatch(leadValue({lead: cardData, type: Strings.creation_edit_type}));
        navigate(Path.lead);
        break;
      case 'Mcc':
        dispatch(
          setMcclistValue({mcc: cardData, type: Strings.creation_edit_type}),
        );
        navigate(Path.mcc);
        break;
      case 'on_hold':
        dispatch(
          loanValue({
            loan: cardData,
            type: Strings.creation_edit_type,
          }),
        );
        navigate('/loan-application/onhold/applicants');

        break;
      case 'QDE':
        dispatch(
          loanValue({
            loan: cardData,
            type: Strings.creation_edit_type,
          }),
        );
        navigate(Path.loan_applicant);

        break;
      case 'DDE':
        dispatch(
          loanValue({
            loan: cardData,
            type: Strings.creation_edit_type,
          }),
        );
        navigate(Path.loan_dde_applicant);

        break;
      case 'Field Investigation':
        dispatch(
          loanValue({
            loan: cardData,
            type: Strings.creation_edit_type,
          }),
        );
        navigate(Path.loan_fi_applicant);

        break;
      case 'Review & FI':
        dispatch(
          loanValue({
            loan: cardData,
            type: Strings.creation_edit_type,
          }),
        );
        navigate(Path.loan_review_fi_applicant);

        break;
      case 'Review':
        dispatch(
          loanValue({
            loan: cardData,
            type: Strings.creation_edit_type,
          }),
        );
        navigate(Path.loan_dde_applicant);

        break;
      case 'Personal Discussion':
        dispatch(
          loanValue({
            loan: cardData,
            type: Strings.creation_edit_type,
          }),
        );
        navigate(Path.loan_personal_dis_applicant);

        break;
      case Strings.loan_applications.dashboard_type_eligiblity:
        dispatch(
          loanValue({
            loan: cardData,
            type: Strings.creation_edit_type,
          }),
        );
        navigate(Path.loan_eligibility_applicant);

        break;

      case Strings.loan_applications.dashboard_type_con:
        dispatch(
          loanValue({
            loan: cardData,
            type: Strings.creation_edit_type,
          }),
        );
        navigate(Path.loan_conversation_applicant);

        break;
      case Strings.loan_applications.dashboard_type_approval_flow:
        dispatch(
          loanValue({
            loan: cardData,
            type: Strings.creation_edit_type,
          }),
        );
        navigate(Path.loan_approval_flow_applicant);

        break;
      case Strings.loan_applications.dashboard_type_loan_booking:
        dispatch(
          loanValue({
            loan: cardData,
            type: Strings.creation_edit_type,
          }),
        );
        navigate(Path.loan_loan_booking_applicant);

        break;
      case Strings.loan_applications.dashboard_type_doc_esign:
        dispatch(
          loanValue({
            loan: cardData,
            type: Strings.creation_edit_type,
          }),
        );
        navigate(Path.loan_document_esign_applicant);

        break;
      case Strings.loan_applications.dashboard_type_doc_verify:
        dispatch(
          loanValue({
            loan: cardData,
            type: Strings.creation_edit_type,
          }),
        );
        navigate(Path.loan_document_verify_applicant);
        break;
      case Strings.loan_applications.dashboard_type_disbursement:
        dispatch(
          loanValue({
            loan: cardData,
            type: Strings.creation_edit_type,
          }),
        );
        navigate(Path.loan_disbursement_applicant);

        break;
      case Strings.loan_applications.dashboard_type_part_approval:
        dispatch(
          loanValue({
            loan: cardData,
            type: Strings.creation_edit_type,
          }),
        );
        navigate(Path.loan_partner_approval_appli);

        break;
      case Strings.loan_applications.dashboard_type_order_con:
        dispatch(
          loanValue({
            loan: cardData,
            type: Strings.creation_edit_type,
          }),
        );
        navigate(Path.loan_order_con_applicant);

        break;
      default:
        break;
    }

    handleMenuClose();
  };

  const handleReject = event => {
    event.stopPropagation();
    if (isLead) {
      dispatch(leadValue({lead: cardData, type: Strings.creation_reject_type}));
    } else {
      dispatch(
        loanValue({
          loan: cardData,
          type: Strings.creation_view_type,
        }),
      );
    }
    handleMenuClose();
    setRejectModal(true);
  };

  const handleCardClick = () => {
    if (
      !(
        ((isQDE && !hasEditValue(roleBased?.qde)) ||
          (isDDE && !hasEditValue(roleBased?.dde)) ||
          (isFI && !hasEditValue(roleBased?.field_investigation)) ||
          (isReviewFI && !hasEditValue(roleBased?.review_and_fi)) ||
          (isReviewCD && !hasEditValue(roleBased?.review)) ||
          (isPersonalDiscussion &&
            !hasEditValue(roleBased?.personal_discussion)) ||
          isOnhold ||
          (isEligiblity &&
            !hasEditValue(roleBased?.eligibility_check_and_cam)) ||
          (isApprovalFLow && !hasEditValue(roleBased?.approval_flow)) ||
          (isLoanBooking && !hasEditValue(roleBased?.loan_booking)) ||
          (isDocEsign && !hasEditValue(roleBased?.document_execution)) ||
          (isDocVerify && !hasEditValue(roleBased?.document_verification)) ||
          (isDisbursement && !hasEditValue(roleBased?.disbursement)) ||
          isConversation ||
          (isOrderConfirmation &&
            !hasEditValue(roleBased?.order_confirmation)) ||
          (isManageAssignee && !true) ||
          (isPartnerApproval && !true)) &&
        cardData.status === 'READY'
      )
    ) {
      switch (dashboardType) {
        case 'Lead':
          dispatch(
            leadValue({lead: cardData, type: Strings.creation_view_type}),
          );
          navigate(Path.lead);
          break;
        case 'Mcc':
          dispatch(
            setMcclistValue({mcc: cardData, type: Strings.creation_view_type}),
          );
          navigate(Path.mcc);
          break;
        case 'QDE':
          dispatch(
            loanValue({
              loan: cardData,
              type:
                hasEditValue(roleBased?.qde) && cardData.status === 'READY'
                  ? Strings.creation_add_type
                  : Strings.creation_view_type,
            }),
          );
          navigate(Path.loan_applicant);
          break;
        case 'DDE':
          dispatch(
            loanValue({
              loan: cardData,
              type:
                hasEditValue(roleBased.dde) && cardData.status === 'READY'
                  ? Strings.creation_add_type
                  : Strings.creation_view_type,
            }),
          );
          navigate(Path.loan_dde_applicant);
          break;
        case 'Rejected':
          dispatch(
            loanValue({
              loan: cardData,
              type: Strings.creation_reject_type,
            }),
          );
          navigate(Path.loan_rejected_application);
          break;
        case 'Field Investigation':
          dispatch(
            loanValue({
              loan: cardData,
              type:
                hasEditValue(roleBased.field_investigation) &&
                cardData.status === 'READY'
                  ? Strings.creation_add_type
                  : Strings.creation_view_type,
            }),
          );
          navigate(Path.loan_fi_applicant);

          break;
        case 'Review & FI':
          dispatch(
            loanValue({
              loan: cardData,
              type:
                hasEditValue(roleBased.review_and_fi) &&
                cardData.status === 'READY'
                  ? Strings.creation_add_type
                  : Strings.creation_view_type,
            }),
          );
          navigate(Path.loan_review_fi_applicant);

          break;
        case 'Review':
          dispatch(
            loanValue({
              loan: cardData,
              type:
                hasEditValue(roleBased.review) && cardData.status === 'READY'
                  ? Strings.creation_add_type
                  : Strings.creation_view_type,
            }),
          );
          navigate(Path.loan_dde_applicant);
          break;
        case 'Personal Discussion':
          dispatch(
            loanValue({
              loan: cardData,
              type:
                hasEditValue(roleBased.personal_discussion) &&
                cardData.status === 'READY'
                  ? Strings.creation_add_type
                  : Strings.creation_view_type,
            }),
          );
          navigate(Path.loan_personal_dis_applicant);

          break;
        case 'on_hold':
          dispatch(
            loanValue({
              loan: cardData,
              type: Strings.creation_view_type,
            }),
          );
          navigate(Path.loan_onhold_applicant);

          break;
        case Strings.loan_applications.dashboard_type_eligiblity:
          dispatch(
            loanValue({
              loan: cardData,
              type:
                true && cardData.status === 'READY'
                  ? Strings.creation_add_type
                  : Strings.creation_view_type,
            }),
          );
          navigate(Path.loan_eligibility_applicant);

          break;
        case Strings.loan_applications.dashboard_type_con:
          dispatch(
            loanValue({
              loan: cardData,
              type: Strings.creation_view_type,
            }),
          );
          navigate(Path.loan_conversation_applicant);
          break;
        case Strings.loan_applications.dashboard_type_approval_flow:
          dispatch(
            loanValue({
              loan: cardData,
              type:
                true && cardData.status === 'READY'
                  ? Strings.creation_add_type
                  : Strings.creation_view_type,
            }),
          );
          navigate(Path.loan_approval_flow_applicant);

          break;
        case Strings.loan_applications.dashboard_type_loan_booking:
          dispatch(
            loanValue({
              loan: cardData,
              type:
                true && cardData.status === 'READY'
                  ? Strings.creation_add_type
                  : Strings.creation_view_type,
            }),
          );
          navigate(Path.loan_loan_booking_applicant);

          break;
        case Strings.loan_applications.dashboard_type_doc_esign:
          dispatch(
            loanValue({
              loan: cardData,
              type:
                true && cardData.status === 'READY'
                  ? Strings.creation_add_type
                  : Strings.creation_view_type,
            }),
          );
          navigate(Path.loan_document_esign_applicant);

          break;
        case Strings.loan_applications.dashboard_type_doc_verify:
          dispatch(
            loanValue({
              loan: cardData,
              type:
                true && cardData.status === 'READY'
                  ? Strings.creation_add_type
                  : Strings.creation_view_type,
            }),
          );
          navigate(Path.loan_document_verify_applicant);

          break;
        case Strings.loan_applications.dashboard_type_part_approval:
          dispatch(
            loanValue({
              loan: cardData,
              type: Strings.creation_view_type,
            }),
          );
          navigate(Path.loan_partner_approval_appli);

          break;
        case Strings.loan_applications.dashboard_type_disbursement:
          dispatch(
            loanValue({
              loan: cardData,
              type:
                true && cardData.status === 'READY'
                  ? Strings.creation_add_type
                  : Strings.creation_view_type,
            }),
          );
          isDisbursement && cardData?.status === 'READY' && productCategories === 'Surabhi-DCL-Unsecured' ? callLmsBrNetApi()
            : navigate(Path.loan_disbursement_applicant);
          break;
        case Strings.loan_applications.dashboard_type_order_con:
          dispatch(
            loanValue({
              loan: cardData,
              type:
                hasEditValue(roleBased?.order_confirmation) &&
                cardData.status === 'READY'
                  ? Strings.creation_add_type
                  : Strings.creation_view_type,
            }),
          );
          navigate(Path.loan_order_con_applicant);
          break;
        case Strings.manageReassignement.manageReassignementHeader:
          dispatch(
            loanValue({
              loan: cardData,
              type: Strings.creation_edit_type,
            }),
          );
          navigate(Path.manage_reassign_detail);

          break;
        default:
          break;
      }
    }
  };

  const renderMenuItems = () => {
    const {status} = cardData;

    if (
      status === 'Incomplete' ||
      status === 'Follow_up' ||
      status === 'INCOMPLETE' ||
      isOnhold ||
      isOrderConfirmation
    ) {
      return [
        <MenuItem key={Strings.creation_edit_type} onClick={handleEdit}>
          <span className="text-medium-14px">Edit</span>
        </MenuItem>,
        <MenuItem key={Strings.creation_reject_type} onClick={handleReject}>
          <span className="text-medium-14px">Reject</span>
        </MenuItem>,
      ];
    }
    if (isMcc || isConversation) {
      return [
        <MenuItem key={Strings.creation_edit_type} onClick={handleEdit}>
          <span className="text-medium-14px">Edit</span>
        </MenuItem>,
      ];
    }
    if (
      (isQDE ||
        isDDE ||
        isFI ||
        isReviewFI ||
        isReviewCD ||
        isPersonalDiscussion ||
        isEligiblity ||
        isApprovalFLow ||
        isLoanBooking ||
        isDocEsign ||
        isDocVerify ||
        isDisbursement ||
        isPartnerApproval) &&
      status == 'READY'
    ) {
      return [
        <MenuItem key={Strings.creation_edit_type} onClick={handleReject}>
          <span className="text-medium-14px">Reject</span>
        </MenuItem>,
      ];
    }

    return null;
  };

  const handleKeyDown = event => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleCardClick();
    }
  };

  return (
    <Box
      onClick={handleCardClick}
      onKeyDown={handleKeyDown}
      tabIndex={0}
      className={nameCard.nameCard_container}>
      <Box className={nameCard.nameCard_initial}>
        <Box
          className={`text-medium-24px ${nameCard.nameCard_initial_circle}`}
          sx={{
            paddingTop: isMcc ? '5px' : '0px',
          }}>
          {isLead ? (
            getInitial(cardData?.contactDetails?.firstName)
          ) : isMcc ? (
            <MccLogo />
          ) : isQDE ||
            isRejectApplication ||
            isDDE ||
            isFI ||
            isReviewFI ||
            isReviewCD ||
            isPersonalDiscussion ||
            isOnhold ||
            isEligiblity ||
            isConversation ||
            isOrderConfirmation ||
            isApprovalFLow ||
            isLoanBooking ||
            isDocEsign ||
            isDocVerify ||
            isDisbursement ||
            isPartnerApproval ? (
            getInitial(cardData?.applicantName || 'N/A')
          ) : isManageAssignee ? (
            getInitial(cardData?.fullName)
          ) : null}
        </Box>
      </Box>

      <CardContent className={nameCard.nameCard_card_content}>
        <Box className={`text-bold-16px ${nameCard.nameCard_name}`}>
          {isLead
            ? cardData?.contactDetails?.fullName
            : isMcc
            ? cardData?.mccName
            : isQDE ||
              isRejectApplication ||
              isDDE ||
              isFI ||
              isReviewFI ||
              isReviewCD ||
              isPersonalDiscussion ||
              isOnhold ||
              isEligiblity ||
              isConversation ||
              isOrderConfirmation ||
              isApprovalFLow ||
              isLoanBooking ||
              isDocEsign ||
              isDocVerify ||
              isDisbursement ||
              isPartnerApproval
            ? cardData.applicantName || 'N/A'
            : isManageAssignee
            ? cardData?.fullName
            : null}
        </Box>
        <Box className={`text-regular-12px ${nameCard.nameCard_number}`}>
          {isLead ? (
            cardData?.contactDetails?.mobileNumber
          ) : isMcc ? (
            cardData?.mccId
          ) : isQDE ||
            isRejectApplication ||
            isDDE ||
            isFI ||
            isReviewFI ||
            isReviewCD ||
            isPersonalDiscussion ||
            isOnhold ||
            isEligiblity ||
            isConversation ||
            isOrderConfirmation ||
            isApprovalFLow ||
            isLoanBooking ||
            isDocEsign ||
            isDocVerify ||
            isDisbursement ||
            isPartnerApproval ||
            isManageAssignee ? (
            <>
              {cardData?.mobileNumber}
              <span className={nameCard.dot}></span>
              {isManageAssignee ? cardData?.role : cardData?.loanApplicationId}
            </>
          ) : null}
        </Box>
      </CardContent>

      {!(
        ((isQDE && !hasEditValue(roleBased?.qde)) ||
          (isDDE && !hasEditValue(roleBased?.dde)) ||
          (isFI && !hasEditValue(roleBased?.field_investigation)) ||
          (isReviewFI && !hasEditValue(roleBased?.review_and_fi)) ||
          (isReviewCD && !hasEditValue(roleBased?.review)) ||
          (isPersonalDiscussion &&
            !hasEditValue(roleBased?.personal_discussion)) ||
          isOnhold ||
          (isEligiblity &&
            !hasEditValue(roleBased?.eligibility_check_and_cam)) ||
          (isApprovalFLow && !hasEditValue(roleBased?.approval_flow)) ||
          (isLoanBooking && !hasEditValue(roleBased?.loan_booking)) ||
          (isDocEsign && !hasEditValue(roleBased?.document_execution)) ||
          (isDocVerify && !hasEditValue(roleBased?.document_verification)) ||
          (isDisbursement && !hasEditValue(roleBased?.disbursement)) ||
          isConversation ||
          (isOrderConfirmation &&
            !hasEditValue(roleBased?.order_confirmation)) ||
          (isPartnerApproval && false)) &&
        cardData.status === 'READY'
      ) &&
        (showKebabMenu ? (
          <IconButton aria-label="settings" onClick={handleMenuOpen}>
            <KebabMenu />
          </IconButton>
        ) : showDownloadedApp ? (
          <IconButton aria-label="downloadedFile">
            <DisbursementDownload onClick={handleCardClick} />
          </IconButton>
        ) : (
          <IconButton aria-label="View" onClick={handleCardClick}>
            <ArrowForwardIcon />
          </IconButton>
        ))}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        onClick={event => event.stopPropagation()}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{
          style: {
            maxHeight: 'auto',
            width: '146px',
            boxShadow: 'none',
            border: '1px solid #ccc',
            borderRadius: '8px',
            padding: 0,
          },
        }}>
        {renderMenuItems()}
      </Menu>
      <ModalwithButton
        open={breRejectedModal}
        message={'Application has been Rejected'}
        subMessage={breMessage}
        rejectedLottie
      />
    </Box>
  );
};

NameCard.propTypes = {
  cardData: PropTypes.any,
  setRejectModal: PropTypes.any,
  dashboardType: PropTypes.string,
};

export default NameCard;
